import debounce from 'lodash/debounce'
import TableButton from '../../../@core/components/buttons/TableButton.vue'
import customDropdown from '../../../components/dropdown/customDropdown.vue'
import AclDeviceTableForm from '../../../@core/components/table-from/AclDeviceTableForm.vue'

export default {
  name: 'AclDeviceTable',
  components: {
    TableButton,
    AclDeviceTableForm,
    customDropdown,
  },

  data() {
    return {
      // filter
      search: null,
      isAttendanceTrackingFilter: 'all_data',
      isDeviceAccessFilter: 'all_data',
      attendanceTrackingOptions: [
        { label: 'All', value: 'all_data' },
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
      ],
      deviceAccessOptions: [
        { label: 'All', value: 'all_data' },
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
      ],

      tabs: 0,
      id: 'tag',
      type: null,
      totalCount: 0,
      currentPage: 1,
      perPage: 10,
      loading: true,
      sortBy: null,
      sortDesc: null,
      fields: [
        {
          key: 'id',
          label: 'ID',
          sortable: true,
          thStyle: { width: '200px' },
          tdStyle: { width: '200px' },
        },
        {
          key: 'name',
          label: 'Name',
          sortable: true,
          thStyle: { width: '100px' },
          tdStyle: { width: '100px' },
        },
        {
          key: 'is_device_access',
          label: 'Office Access Device',
          sortable: false,
          thStyle: { width: '100px' },
          tdStyle: { width: '100px' },
        },
        {
          key: 'is_attendance_tracking',
          label: 'Attendance Tracking',
          sortable: false,
          thStyle: { width: '100px' },
          tdStyle: { width: '100px' },
          // tdStyle: { width: '50px' },
        },
        {
          key: 'action',
          label: 'Action',
          thClass: 'text-right',
          tdClass: 'text-right',
          thStyle: { width: '120px' },
          tdStyle: { width: '120px' },
        },
      ],
      items: [],
      aclDevices: [],
      sortBy1: null,
      sortDesc1: null,
    }
  },
  computed: {
    debouncedSearch: {
      get() {
        return this.search
      },
      set: debounce(function (value) {
        this.search = value
        this.getAclDeviceData()
      }, 750),
    },
  },
  watch: {
    perPage() {
      this.getAclDeviceData()
    },
    currentPage: {
      handler(value) {
        if (value) {
          this.getAclDeviceData()
        }
      },
    },
  },
  mounted() {
    this.getAclDeviceData()
  },
  methods: {
    /**
     * @description For Edit tag color of tag to tagTableForm
     * @emits edit-tag
     */
    edit(data) {
      this.$refs.AclDeviceTableForm.id = true
      this.$refs.AclDeviceTableForm.aclDeviceId = data.id
      this.$refs.AclDeviceTableForm.name = data.name
      this.$refs.AclDeviceTableForm.is_attendance_tracking = !!data.is_attendance_tracking
      this.$refs.AclDeviceTableForm.is_device_access = !!data.is_device_access
      this.$refs.AclDeviceTableForm.code = data.code ? data.code : null
      this.$root.$emit('bv::toggle::collapse', 'addacldevice')
    },

    async getAclDeviceData(page) {
      this.loading = true

      this.currentPage = page || this.currentPage
      const input = {
        page: this.currentPage,
        per_page: this.perPage,
        sort_field: this.sortBy1,
        sort_order: this.sortDesc1 ? 'asc' : 'desc',
        search: this.search,
      }
      if (this.isAttendanceTrackingFilter && this.isAttendanceTrackingFilter !== 'all_data') {
        input.is_attendance_tracking = this.isAttendanceTrackingFilter === 'yes' ? 1 : 0
      }
      if (this.isDeviceAccessFilter && this.isDeviceAccessFilter !== 'all_data') {
        input.is_device_access = this.isDeviceAccessFilter === 'yes' ? 1 : 0
      }
      const response = await this.getHTTPPostResponse(
        'admin/master/acl-device',
        input,
        false,
      )
      if (response && response.data) {
        const { data } = response
        this.totalCount = data.count
        this.aclDevices = data.acl_devices
      }
      this.loading = false
    },

    /**
     * Toggle is_attendance_tracking with SweetAlert confirmation
     */
    async changeTracking(item) {
      const willEnable = !item.is_attendance_tracking
      const label = willEnable ? 'Enable' : 'Disable'
      const title = `Are you sure you want to ${label} tracking for this device?`
      const confirmation = await this.conformationAlert(false, title, label)
      if (confirmation.isConfirmed === true) {
        const response = await this.getHTTPPutResponse(
          `admin/master/acl-device/update/${item.id}`,
          { name: item.name, is_attendance_tracking: willEnable ? 1 : 0 },
          true,
        )
        if (response && response.status === 200) {
          this.getAclDeviceData()
        }
      } else {
        this.getAclDeviceData()
      }
    },

    /**
     * Toggle is_device_access with SweetAlert confirmation
     */
    async changeDeviceAccess(item) {
      const willEnable = !item.is_device_access
      const label = willEnable ? 'Enable' : 'Disable'
      const title = `Are you sure you want to ${label} Office Access Device for this device?`
      const confirmation = await this.conformationAlert(false, title, label)
      if (confirmation.isConfirmed === true) {
        const response = await this.getHTTPPutResponse(
          `admin/master/acl-device/update/${item.id}`,
          { name: item.name, is_device_access: willEnable ? 1 : 0 },
          true,
        )
        if (response && response.status === 200) {
          this.getAclDeviceData()
        }
      } else {
        this.getAclDeviceData()
      }
    },

    /**
     *  confirmation to delete ACL Device
     * @param {id} ACL Device id
     * @returns if conform to delete call deleteAclDevice function
     */
    async deleteConfirmation(id) {
      const value = await this.conformationAlert(true)
      if (value.isConfirmed === true) {
        this.deleteAclDevice(id)
      }
    },
    /**
     *  delete ACL Device
     * @method DELETE
     * @param {id}  ACL Device id
     * @returns delete ACL Device
     */
    async deleteAclDevice(id) {
      const response = await this.getHTTPDeleteResponse(
        `admin/master/acl-device/delete/${id}`,
        {},
        true,
      )
      if (response && response.status === 200) {
        this.getAclDeviceData()
      }
    },
    clearFilter() {
      this.perPage = 10
      this.search = null
      this.isAttendanceTrackingFilter = 'all_data'
      this.isDeviceAccessFilter = 'all_data'
      this.getAclDeviceData(1)
    },
  },
}